import { Component } from '@angular/core';
import { FooterComponent } from '../../../../landing-page-v2/components/footer/footer.component';
import { FixedCallComponent } from '../../fixed-call/fixed-call.component';
import { HeaderComponent } from '../../../../landing-page-v2/components/header/header.component';

@Component({
  selector: 'app-shopify-stores-industry',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, FixedCallComponent],

  templateUrl: './shopify-stores-industry.component.html',
  styleUrl: './shopify-stores-industry.component.scss',
})
export class ShopifyStoresIndustryComponent {
  constructor() {}
}
